/* eslint-disable default-case */
import {
  LOAD_TRACKS,
  PUT_TRACKS,
  LOADING,
  TOGGLE_SELECTED_TRACK,
  TOGGLE_HIDE_ENDED,
  SAVE_REF,
  UPDATE_TRACKS_OUTDATE,
  UPDATE_TRACKS,
} from "./actions";
import { isArr } from "../../utilities/isArr";
import { DO_LOGOUT } from "../Login/actions";
import { indexOf } from "lodash";

const initialState = {
  loading: false,
  tracks: [],
  tracksRef: {},
  tracksTheme: [],
  outdatedLoaded: false,
  tracksExtra: [],
  tracksAssoc: {},
  tracksAssocTheme: {},
  selected: [],
  selectedTheme: [],
  selecedExtra: [],
  hideEnded: true,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_TRACKS_OUTDATE:
      return {
        ...state,
        tracks: state.tracks.map((el) =>
          payload.indexOf(el.id) === -1 ? el : { ...el, clipEnded: false }
        ),
      };
    case SAVE_REF:
      return {
        ...state,
        tracksRef: {
          ...state.tracksRef,
          [String(payload.theme)]: payload.tracksRef,
        },
      };
    case UPDATE_TRACKS:
      return {
        ...state,
        tracks: state.tracks.map((el) => payload[el.id] || el),
      };
    case TOGGLE_HIDE_ENDED:
      return {
        ...state,
        hideEnded: payload,
      };

    case LOAD_TRACKS:
      return {
        ...state,
        // tracks: [],
        // tracksTheme: [],
        selected: [...state.selected],
      };

    case LOADING:
      return {
        ...state,
        loading: payload,
      };

    case PUT_TRACKS:
      if (payload.theme) {
        if (payload.theme === "extra")
          return {
            ...state,
            tracksExtra: payload.tracks,
            tracksAssocTheme: payload.tracksAssoc,
          };
        return {
          ...state,
          tracksTheme: payload.tracks,
          tracksAssocTheme: payload.tracksAssoc,
        };
      } else {
        return {
          ...state,
          tracks: payload.tracks,
          tracksAssoc: payload.tracksAssoc,
          outdatedLoaded: payload.outdate || state.outdatedLoaded,
        };
      }

    case TOGGLE_SELECTED_TRACK:
      const { id, selected, onlyOne, ids } = payload;
      if (typeof ids !== "undefined") {
        return {
          ...state,
          selected: [...ids],
        };
      }
      if (selected === true) {
        return {
          ...state,
          selected:
            state.selected.indexOf(id) === -1
              ? state.selected.concat([id])
              : state.selected,
        };
      } else if (selected === false) {
        return {
          ...state,
          selected:
            state.selected.indexOf(id) !== -1
              ? state.selected.filter((objectId) => objectId !== id)
              : state.selected,
        };
      } else {
        if (onlyOne === true) {
          return {
            ...state,
            selected: state.selected.indexOf(id) === -1 ? [id] : [],
          };
        } else {
          return {
            ...state,
            selected:
              state.selected.indexOf(id) === -1
                ? state.selected.concat([id])
                : state.selected.filter((objectId) => objectId !== id),
          };
        }
      }
    case DO_LOGOUT:
      return initialState;
  }
  return state;
};

export default reducer;
